import React from 'react'
import { Field } from 'redux-form'
import { renderTextField } from './fields'
import { required } from './validators'

import RadioGroup from './RadioGroup'

const ContactType = props => {
  return (
    <>
      <div className="equote-package-additional-details-form--input-group equote-package-additional-details-form--contact-method">
        <label>
          CONTACT INFO <span style={{ color: 'red' }}>*</span>
        </label>
        <div className="equote-package-additional-details-form--input-group--container">
          <div className="equote-package-additional-details-form--input-group equote-package-additional-details-form--input-contact-method">
            <span
              className="equote-package-additional-details-form--input-group--label"
              style={{ paddingRight: '55px' }}
            >
              How may we
              <br /> contact you?
            </span>
            <div>
              <RadioGroup
                options={[
                  { label: 'Phone', value: 'Phone' },
                  { label: 'Email', value: 'Email' }
                ]}
                displayFlex
                name="Contact method"
                isRadio
              />
              <div className="equote-package-additional-details-form--contact-method-value">
                <Field
                  name={props.contactMethod}
                  component={renderTextField}
                  inputClassName="equote-package-additional-details-form--textInput"
                  label={`Enter Your ${props.contactMethod} ${
                    props.contactMethod === 'Phone' ? 'Number' : 'Address'
                  }`}
                  validate={required}
                  groupClassName="equote-package-additional-details-form--input-comments"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ContactType
